export const MenuItems = [
  {
    title: "Home",
    path: "/",
    cName: "dropdown-link",
  },
  {
    title: "Fixed Route",
    path: "/FixedRoute",
    cName: "dropdown-link",
  },
  {
    title: "Special Services",
    path: "/SpecialServices",
    cName: "dropdown-link",
  },
];
